const SESSION_KEY = 'conversation-bank-ui';
const quoteChars = '"\u201C\u201D';

export const FLOW_POSITIONS = ['START', 'CONTINUE', 'PITCH', 'INVITE', 'CONFIRM'];

export const unwrapCopyText = value => {
  if (value === undefined || value === null) return '';
  let text = String(value)
    .replace(/\r\n/g, '\n')
    .trim();
  while (text.length >= 2 && quoteChars.includes(text[0]) && quoteChars.includes(text[text.length - 1])) {
    text = text.slice(1, -1).trim();
  }
  return text;
};

export const applySafePlaceholders = (text, context = {}) => {
  if (!text) return '';
  const replacements = {
    name: context.name || '',
    rep: context.rep || '',
    store: context.store || '',
    number: context.number || ''
  };
  return String(text).replace(/\[(Name|Rep|store|number)\]/gi, (match, key) => {
    const value = replacements[String(key).toLowerCase()];
    return value ? value : match;
  });
};

export const formatConversationCopy = (text, placeholderContext) =>
  applySafePlaceholders(unwrapCopyText(text), placeholderContext);

export const copyConversationText = async (text, placeholderContext) => {
  const value = formatConversationCopy(text, placeholderContext);
  if (!value) return '';
  if (navigator.clipboard && window.isSecureContext && navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(value);
    return value;
  }
  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
  return value;
};

export const readConversationBankSession = () => {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
};

export const writeConversationBankSession = patch => {
  const next = { ...readConversationBankSession(), ...patch };
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(next));
  return next;
};

export const conversationBankSearchPath = ({ contactId, returnTo, id } = {}) => {
  const params = new URLSearchParams();
  if (contactId) params.set('contactId', contactId);
  if (returnTo) params.set('returnTo', returnTo);
  const query = params.toString();
  const base = id ? `/conversation-bank/${id}` : '/conversation-bank';
  return query ? `${base}?${query}` : base;
};

export const flowPositionVariant = position =>
  ({
    START: 'primary',
    CONTINUE: 'info',
    PITCH: 'warning',
    INVITE: 'success',
    CONFIRM: 'dark'
  }[position] || 'secondary');
